import { useEffect, useRef, useState, type ReactNode } from "react";

export function Appear({ className = "", children }: { className?: string; children: ReactNode }) {
  const [play, setPlay] = useState(false);
  useEffect(() => {
    const frame = requestAnimationFrame(() => setPlay(true));
    return () => cancelAnimationFrame(frame);
  }, []);
  return <div className={`${className} ${play ? "crm-fade" : "opacity-0"}`.trim()}>{children}</div>;
}

export function FadeSwap({ id, className = "", children }: { id: string; className?: string; children: ReactNode }) {
  const next = useRef(children);
  next.current = children;
  const frame = useRef({ id, node: children });
  if (frame.current.id === id) frame.current = { id, node: children };
  const [leaving, setLeaving] = useState(false);
  const [epoch, setEpoch] = useState(0);

  useEffect(() => {
    if (frame.current.id === id) return;
    if (!frame.current.id) {
      frame.current = { id, node: next.current };
      setEpoch((value) => value + 1);
      return;
    }
    setLeaving(true);
    const timer = window.setTimeout(() => {
      frame.current = { id, node: next.current };
      setLeaving(false);
      setEpoch((value) => value + 1);
    }, 220);
    return () => window.clearTimeout(timer);
  }, [id]);

  const phaseOut = leaving || (frame.current.id !== id && frame.current.id !== "");
  return (
    <div key={phaseOut ? `out-${frame.current.id}` : `${id}-${epoch}`} className={`${className} ${phaseOut ? "crm-fade-out" : "crm-fade"}`.trim()}>
      {phaseOut ? frame.current.node : children}
    </div>
  );
}
